export function downloadBlobFile(data, filename, mimeType) {
  const type = mimeType || "text/csv;charset=utf-8";
  const url = URL.createObjectURL(new Blob([data], { type }));
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    link.remove();
    URL.revokeObjectURL(url);
  }, 0);
}
